import { createElementVNode as _createElementVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1230d4ac"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "testTool"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "testToolBox"
}, [/*#__PURE__*/_createElementVNode("h1", {
  class: "title"
}, "云起AI安全大脑"), /*#__PURE__*/_createElementVNode("div", {
  class: "describe"
}, " 云起AI安全大脑是一款专为企业级大模型系统设计的全方位解决方案，旨在提供智能体管理和模型管理的一体化平台，为企业级用户提供了便捷、安全的智能体管理和模型管理服务，助力用户构建高效、稳定的AI系统。各智能体可通过知识、工具以及记忆引擎，不断提升对用户安全场景理解，易使用、自学习、自行动，高效完成安全任务闭环，大幅提升用户工作效率。 ")], -1));
const _hoisted_3 = {
  class: "interaction"
};
const _hoisted_4 = {
  class: "interaction-box"
};
const _hoisted_5 = {
  class: "radian"
};
const _hoisted_6 = {
  class: "modular one"
};
const _hoisted_7 = {
  class: "modular-icon icon1"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "neirogn")])], -1));
const _hoisted_9 = {
  class: "icon"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text"
}, "5G", -1));
const _hoisted_11 = {
  class: "modular two"
};
const _hoisted_12 = {
  class: "modular-icon icon2"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "neirogn")])], -1));
const _hoisted_14 = {
  class: "icon"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text"
}, "智能汽车", -1));
const _hoisted_16 = {
  class: "modular three"
};
const _hoisted_17 = {
  class: "modular-icon icon3"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "neirogn")])], -1));
const _hoisted_19 = {
  class: "icon"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text"
}, "物联网", -1));
const _hoisted_21 = {
  class: "modular four"
};
const _hoisted_22 = {
  class: "modular-icon icon4"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "neirogn")])], -1));
const _hoisted_24 = {
  class: "icon"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text"
}, "大型制造业", -1));
const _hoisted_26 = {
  class: "radian-right"
};
const _hoisted_27 = {
  class: "modular one"
};
const _hoisted_28 = {
  class: "modular-icon icon5"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "neirogn")])], -1));
const _hoisted_30 = {
  class: "icon"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text"
}, "能源", -1));
const _hoisted_32 = {
  class: "modular two"
};
const _hoisted_33 = {
  class: "modular-icon icon6"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "neirogn")])], -1));
const _hoisted_35 = {
  class: "icon"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text"
}, "金融", -1));
const _hoisted_37 = {
  class: "modular three"
};
const _hoisted_38 = {
  class: "modular-icon icon7"
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "neirogn")])], -1));
const _hoisted_40 = {
  class: "icon"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text"
}, "Web3.0", -1));
const _hoisted_42 = {
  class: "modular four"
};
const _hoisted_43 = {
  class: "modular-icon icon8"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "neirogn")])], -1));
const _hoisted_45 = {
  class: "icon"
};
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text"
}, "更多", -1));
const _hoisted_47 = {
  class: "fuzz-box-left"
};
const _hoisted_48 = {
  class: "fuzz-box one"
};
const _hoisted_49 = {
  class: "img"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "neirogn")], -1));
const _hoisted_51 = {
  class: "fuzz-box two"
};
const _hoisted_52 = {
  class: "img"
};
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "neirogn")], -1));
const _hoisted_54 = {
  class: "fuzz-box three"
};
const _hoisted_55 = {
  class: "img"
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "neirogn")], -1));
const _hoisted_57 = {
  class: "theme-box"
};
const _hoisted_58 = {
  class: "shadow"
};
const _hoisted_59 = {
  class: "small-icon one"
};
const _hoisted_60 = {
  class: "small-icon two"
};
const _hoisted_61 = {
  class: "small-icon three"
};
const _hoisted_62 = {
  class: "small-icon four"
};
const _hoisted_63 = {
  class: "small-icon fire"
};
const _hoisted_64 = {
  class: "small-icon six"
};
const _hoisted_65 = {
  class: "rotate-box"
};
const _hoisted_66 = {
  class: "rotate"
};
const _hoisted_67 = {
  class: "theme animationTheme",
  alt: "云起无垠"
};
const _hoisted_68 = {
  class: "electronic",
  alt: "云起无垠"
};
const _hoisted_69 = {
  class: "platform",
  alt: "云起无垠"
};
const _hoisted_70 = {
  class: "fuzz-box-right"
};
const _hoisted_71 = {
  class: "fuzz-box one"
};
const _hoisted_72 = {
  class: "img"
};
const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "neirogn")], -1));
const _hoisted_74 = {
  class: "fuzz-box two"
};
const _hoisted_75 = {
  class: "img"
};
const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "neirogn")], -1));
const _hoisted_77 = {
  class: "fuzz-box three"
};
const _hoisted_78 = {
  class: "img"
};
const _hoisted_79 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "neirogn")], -1));
const _hoisted_80 = {
  class: "chassis-box1"
};
const _hoisted_81 = {
  class: "chassis-box2"
};
import { ref } from 'vue';
import { MOBILE_FUNC } from '@/uitl/currencyFunc';
export default {
  __name: 'DetectionTool',
  setup(__props) {
    let isMobile = MOBILE_FUNC(),
      proportion = ref(null),
      fatherBox = ref(null);
    if (isMobile) {
      // 移动端
      proportion.value = `transform: scale(${window.innerWidth * 0.28 / 375}) translateY(${(window.innerWidth * 0.28 / 375 - 1) * 160}px);`;
      fatherBox.value = `height: ${window.innerWidth * 260 / 375}px;`;
    } else {
      // PC端
      if (window.innerWidth <= 1920) {
        proportion.value = '';
        fatherBox.value = '';
      } else {
        proportion.value = `transform: scale(${window.innerWidth * 1 / 1920}) translateY(${(window.innerWidth * 1 / 1920 - 1) * 175}px);`;
        fatherBox.value = `height: ${window.innerWidth * 700 / 1920}px;`;
      }
    }
    return (_ctx, _cache) => {
      const _directive_lazy = _resolveDirective("lazy");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", {
        class: "soures-box",
        style: _normalizeStyle(_unref(fatherBox))
      }, [_createElementVNode("div", {
        class: "padding16",
        style: _normalizeStyle(_unref(proportion))
      }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("i", _hoisted_7, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/industry-icons.png'), "background-image"]]), _hoisted_8, _withDirectives(_createElementVNode("i", _hoisted_9, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/icon.png'), "background-image"]]), _hoisted_10]), _createElementVNode("div", _hoisted_11, [_withDirectives(_createElementVNode("i", _hoisted_12, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/industry-icons.png'), "background-image"]]), _hoisted_13, _withDirectives(_createElementVNode("i", _hoisted_14, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/icon.png'), "background-image"]]), _hoisted_15]), _createElementVNode("div", _hoisted_16, [_withDirectives(_createElementVNode("i", _hoisted_17, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/industry-icons.png'), "background-image"]]), _hoisted_18, _withDirectives(_createElementVNode("i", _hoisted_19, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/icon.png'), "background-image"]]), _hoisted_20]), _createElementVNode("div", _hoisted_21, [_withDirectives(_createElementVNode("i", _hoisted_22, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/industry-icons.png'), "background-image"]]), _hoisted_23, _withDirectives(_createElementVNode("i", _hoisted_24, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/icon.png'), "background-image"]]), _hoisted_25])])), [[_directive_lazy, require('@/assets/img/index/testModular/radian-left.png'), "background-image"]]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_withDirectives(_createElementVNode("i", _hoisted_28, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/industry-icons.png'), "background-image"]]), _hoisted_29, _withDirectives(_createElementVNode("i", _hoisted_30, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/icon.png'), "background-image"]]), _hoisted_31]), _createElementVNode("div", _hoisted_32, [_withDirectives(_createElementVNode("i", _hoisted_33, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/industry-icons.png'), "background-image"]]), _hoisted_34, _withDirectives(_createElementVNode("i", _hoisted_35, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/icon.png'), "background-image"]]), _hoisted_36]), _createElementVNode("div", _hoisted_37, [_withDirectives(_createElementVNode("i", _hoisted_38, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/industry-icons.png'), "background-image"]]), _hoisted_39, _withDirectives(_createElementVNode("i", _hoisted_40, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/icon.png'), "background-image"]]), _hoisted_41]), _createElementVNode("div", _hoisted_42, [_withDirectives(_createElementVNode("i", _hoisted_43, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/industry-icons.png'), "background-image"]]), _hoisted_44, _withDirectives(_createElementVNode("i", _hoisted_45, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/icon.png'), "background-image"]]), _hoisted_46])])), [[_directive_lazy, require('@/assets/img/index/testModular/radian-right.png'), "background-image"]])]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_withDirectives(_createElementVNode("i", _hoisted_49, null, 512), [[_directive_lazy, require('@/assets/img/index/agent1.svg'), "background-image"]]), _createTextVNode(" 安全培训智能体 "), _hoisted_50]), _createElementVNode("div", _hoisted_51, [_withDirectives(_createElementVNode("i", _hoisted_52, null, 512), [[_directive_lazy, require('@/assets/img/index/agent2.svg'), "background-image"]]), _createTextVNode(" 代码生成智能体 "), _hoisted_53]), _createElementVNode("div", _hoisted_54, [_withDirectives(_createElementVNode("i", _hoisted_55, null, 512), [[_directive_lazy, require('@/assets/img/index/agent3.svg'), "background-image"]]), _createTextVNode(" 漏洞情报智能体 "), _hoisted_56])]), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_withDirectives(_createElementVNode("i", _hoisted_59, null, 512), [[_directive_lazy, require('@/assets/img/index/agent1.svg'), "background-image"]]), _withDirectives(_createElementVNode("i", _hoisted_60, null, 512), [[_directive_lazy, require('@/assets/img/index/agent2.svg'), "background-image"]]), _withDirectives(_createElementVNode("i", _hoisted_61, null, 512), [[_directive_lazy, require('@/assets/img/index/agent3.svg'), "background-image"]]), _withDirectives(_createElementVNode("i", _hoisted_62, null, 512), [[_directive_lazy, require('@/assets/img/index/agent4.svg'), "background-image"]]), _withDirectives(_createElementVNode("i", _hoisted_63, null, 512), [[_directive_lazy, require('@/assets/img/index/agent5.svg'), "background-image"]]), _withDirectives(_createElementVNode("i", _hoisted_64, null, 512), [[_directive_lazy, require('@/assets/img/index/agent6.svg'), "background-image"]])]), _createElementVNode("div", _hoisted_65, [_withDirectives(_createElementVNode("i", _hoisted_66, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/rotate.png'), "background-image"]])]), _withDirectives(_createElementVNode("img", _hoisted_67, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/theme.png')]]), _withDirectives(_createElementVNode("img", _hoisted_68, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/electronic.png')]]), _withDirectives(_createElementVNode("img", _hoisted_69, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/platform.png')]])]), _createElementVNode("div", _hoisted_70, [_createElementVNode("div", _hoisted_71, [_withDirectives(_createElementVNode("i", _hoisted_72, null, 512), [[_directive_lazy, require('@/assets/img/index/agent4.svg'), "background-image"]]), _createTextVNode(" 模糊测试智能体 "), _hoisted_73]), _createElementVNode("div", _hoisted_74, [_withDirectives(_createElementVNode("i", _hoisted_75, null, 512), [[_directive_lazy, require('@/assets/img/index/agent5.svg'), "background-image"]]), _createTextVNode(" 缺陷分析智能体 "), _hoisted_76]), _createElementVNode("div", _hoisted_77, [_withDirectives(_createElementVNode("i", _hoisted_78, null, 512), [[_directive_lazy, require('@/assets/img/index/agent6.svg'), "background-image"]]), _createTextVNode(" 知识问答智能体 "), _hoisted_79])]), _withDirectives(_createElementVNode("div", _hoisted_80, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/chassis.png'), "background-image"]]), _withDirectives(_createElementVNode("div", _hoisted_81, null, 512), [[_directive_lazy, require('@/assets/img/index/testModular/radian-bottom.png'), "background-image"]])])], 4)], 4)])), [[_directive_lazy, require('@/assets/img/index/detectionTool-bg.png'), "background-image"]]);
    };
  }
};